import { useEffect, useState } from "react";
import { useAppSelector } from "store/hooks";
import { companyMetadataSelector, salsaSelector } from "store/selectors";

import useAuth from "hooks/useAuth";

const useAdminPayPage = () => {
  const frameId = "pay-frame-container";
  const frameSelector = `#${frameId}`;

  const salsaEventName = "runpayrollcompleted";
  const salsaDevDomain = "https://components.sandbox.salsa.dev";
  const salsaProdDomain = "https://components.salsa.dev";

  const { getCurrentUserAndCompany } = useAuth();
  const salsaData = useAppSelector(salsaSelector);
  const { salsa, authToken } = salsaData || {};
  const currentCompany = useAppSelector(companyMetadataSelector);
  const [isLoading, setIsLoading] = useState(false);

  const refetchCurrentUserAndCompany = async () => {
    setIsLoading(true);
    await getCurrentUserAndCompany();
    setIsLoading(false);
  };

  useEffect(() => {
    if (salsa) {
      const salsaElement = salsa.elements.create("employer-dashboard", {
        userToken: authToken,
        employerId: currentCompany?.salsaEmployerId,
      });

      salsa.elements.mount(salsaElement, frameSelector);
      return () => {
        salsa.elements.destroy(salsaElement);
      };
    }
  }, [salsa]);

  /*  NOTE::: PAIDSW-1183 - hide subscriptions
  useEffect(() => {
    if (isCompanyWithinTrialPayrollLimit(currentCompany)) {
      const handleMessage = (event: MessageEvent) => {
        if (![salsaDevDomain, salsaProdDomain].includes(event.origin)) return;

        if (event.data && event?.data?.payload?.eventName === salsaEventName) {
          const trialEndingSoon =
            currentCompany?.submittedPayrollsAfterFreeTrialStarted ===
            SUBSCRIPTION_TRIAL_PERIOD_PAYROLL_RUNS - 1;
          if (trialEndingSoon) showFreeTrialEndedModal();

          refetchCurrentUserAndCompany();
        } else {
          console.error(
            `Unknown event: ${JSON.stringify(event.data)}. Expected event from Salsa with type: ${salsaEventName}`,
          );
        }
      };

      window.addEventListener("message", handleMessage);
      return () => {
        window.removeEventListener("message", handleMessage);
      };
    }
  }, [currentCompany]); */

  return {
    frameId,
    isLoading,
  };
};

export default useAdminPayPage;
